import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import FAQSection from "./components/FAQSection";
import CategoryGrid from "./components/CategoryGrid";
import ArticlePreviewSection from "./components/ArticlePreviewSection";
import CTASection from "./components/CTASection";
import TestimonialSection from "./components/TestimonialSection";
import { faqItems } from "@/mocks/faq";

const siteUrl = import.meta.env.VITE_SITE_URL || "https://cssbuyspreadsheet.gay";

const homeJsonLd = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "name": "CSSBuySpreadsheet",
      "url": siteUrl,
      "logo": "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/d367cf6745ee47f3fc82c76d3a54c50c.png",
      "description": "A principal plataforma em português para encontrar links CSSBuy confiáveis, vendedores verificados e planilhas atualizadas.",
      "sameAs": [
        "https://kaspreadsheet.com"
      ]
    },
    {
      "@type": "WebSite",
      "name": "CSSBuySpreadsheet",
      "url": siteUrl,
      "description": "CSSBuySpreadsheet é a principal plataforma em português para encontrar links confiáveis CSSBuy, vendedores verificados e planilhas atualizadas. Compre da China com segurança.",
      "inLanguage": "pt-BR",
      "potentialAction": {
        "@type": "SearchAction",
        "target": {
          "@type": "EntryPoint",
          "urlTemplate": "https://kaspreadsheet.com/search?q={search_term_string}"
        },
        "query-input": "required name=search_term_string"
      }
    },
    {
      "@type": "FAQPage",
      "mainEntity": faqItems.map((item) => ({
        "@type": "Question",
        "name": item.question,
        "acceptedAnswer": {
          "@type": "Answer",
          "text": item.answer
        }
      }))
    }
  ]
};

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homeJsonLd) }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <FAQSection />
        <CategoryGrid />
        <ArticlePreviewSection />
        <CTASection />
        <TestimonialSection />
      </main>
      <Footer />
    </div>
  );
}